export default "__VITE_ASSET__CAyoxKOF__"